import { render, staticRenderFns } from "./ManageHoliday.vue?vue&type=template&id=d0b60e92&scoped=true"
import script from "./ManageHoliday.vue?vue&type=script&lang=js"
export * from "./ManageHoliday.vue?vue&type=script&lang=js"
import style0 from "./ManageHoliday.vue?vue&type=style&index=0&id=d0b60e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b60e92",
  null
  
)

export default component.exports